import { TFunction } from 'i18next';
import * as Yup from 'yup';

export type AcreageUnits = 'acres' | 'feet';

export type AcreageAndContainmentFormValues = {
  sizeUnit: AcreageUnits;
  feetLength: number | null;
  feetWidth: number | null;
  acreage: number | null;
  containment: number | null;
};

export const getAcreageAndContainmentValidationSchema = (
  t: TFunction,
): {
  sizeUnit: Yup.StringSchema<string | undefined>;
  feetLength: Yup.NumberSchema<number | null | undefined>;
  feetWidth: Yup.NumberSchema<number | null | undefined>;
  acreage: Yup.NumberSchema<number | null | undefined>;
  containment: Yup.NumberSchema<number | null | undefined>;
} => {
  return {
    sizeUnit: Yup.string().oneOf(['acres', 'feet']),
    feetLength: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .typeError(t('createEditWildfire.inputs.acreage.required'))
      .min(0, t('createEditWildfire.inputs.acreage.invalidError'))
      .max(9999999, t('createEditWildfire.inputs.acreage.invalidError'))
      .nullable(),
    feetWidth: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .typeError(t('createEditWildfire.inputs.acreage.required'))
      .min(0, t('createEditWildfire.inputs.acreage.invalidError'))
      .max(9999999, t('createEditWildfire.inputs.acreage.invalidError'))
      .nullable(),
    acreage: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .typeError(t('createEditWildfire.inputs.acreage.required'))
      .min(0, t('createEditWildfire.inputs.acreage.invalidError'))
      .max(9999999, t('createEditWildfire.inputs.acreage.invalidError'))
      .nullable(),
    containment: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .typeError(t('createEditWildfire.inputs.containment.required'))
      .min(0, t('createEditWildfire.inputs.containment.invalidError'))
      .max(100, t('createEditWildfire.inputs.containment.invalidError'))
      .integer()
      .nullable(),
  };
};
